import axios from 'axios';
import { useAuthStore } from '@/store/authStore';
import logger from './logger';

const apiClient = axios.create({
  baseURL: import.meta.env.VITE_API_URL as string,
  headers: {
    'Content-Type': 'application/json',
  },
});

apiClient.interceptors.request.use(
  (config) => {
    const authStore = useAuthStore();
    const token = authStore.credential?.token;

    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }

    return config;
  },
  (requestError) => Promise.reject(requestError)
);

apiClient.interceptors.response.use(
  (response) => response,
  (requestError) => {
    if (requestError.response?.status === 401) {
      if (!requestError.config?.skipGlobalError) {
        const message = requestError.response.data?.message || 'Unauthorized';
        logger.showError(message);
      }
    } else if (requestError.response?.status === 400) {
      if (!requestError.config?.skipGlobalError) {
        const message = requestError.response.data?.message || 'Bad Request';
        logger.showError(message);
      }
    } else if (requestError.response?.status === 403) {
      const message = requestError.response.data?.message || '403 Forbidden';
      logger.showError(message);
    } else if (requestError.response?.status === 409) {
      if (!requestError.config?.skipGlobalError) {
        const message = requestError.response.data?.message || 'Conflict';
        logger.showError(message);
      }
    } else if (requestError.response?.status >= 500) {
      if (!requestError.config?.skipGlobalError) {
        const message = requestError.response.data?.message || 'Internal Server Error';
        logger.showError(message);
      }
    }

    return Promise.reject(requestError);
  }
);

export default apiClient;
